import gql from 'graphql-tag';

/**
 * Data of the block project-customer-additional-information: notes, land register fields and the
 * meter number list on `customer`, and the net-registration requirements for the badges. Read
 * through `Project.blocks.customerAdditionalInformation`, which checks the block's read
 * permission.
 */
export const PROJECT_CUSTOMER_ADDITIONAL_INFORMATION_FIELDS = gql`
  fragment projectCustomerAdditionalInformationFields on ProjectCustomerAdditionalInformationBlock {
    id
    number
    customerDescription
    customer {
      field
      fieldSector
      boundary
      electricMeterNumbers {
        number
        description
      }
    }
    netRegistrationRequirements {
      name
      fullfilledState
    }
  }
`;
